module.exports = __webpack_public_path__ + "7caf1b2e924a0ea1d8180ee8d3451b13.jpg";